var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdrChartreuseLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1162,
    height: 433,
    viewBox: "0 0 1162 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.835 199.239L309.786 314.998C298.096 380.127 242.942 432.997 137.12 432.997C31.7742 432.997 -9.37876 377.342 1.76753 314.998L21.8173 199.239C33.5073 133.567 87.5396 80.1191 195.128 80.1191C298.639 80.1191 340.982 136.895 329.835 199.239ZM181.128 172.515C147.145 172.515 131.547 189.222 126.518 216.659L112.619 296.797C107.589 324.641 117.07 340.94 151.053 340.94C184.458 340.94 200.056 324.811 205.085 296.797L218.984 216.659C224.014 189.222 214.091 172.515 181.128 172.515Z",
    fill: "#D4FB41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M587.611 80.1191L570.929 172.492H545.362C499.79 172.492 483.107 185.29 475.342 229.796L440.96 427.883H333.607L366.973 235.364C388.097 116.274 432.551 80.1191 571.505 80.1191H587.611Z",
    fill: "#D4FB41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M591.64 197.916C604.976 122.866 642.811 80.611 731.242 80.611C767.415 80.611 789.642 90.0727 808 101.739L825.815 0H933.147L878.073 314.61C864.16 392.983 817.467 433 708.066 433C604.059 433 560.658 376.298 572.908 305.691L591.64 197.916ZM720.146 341.299C753.503 341.299 769.078 324.648 774.066 297.213L788.556 213.278C793.544 186.148 784.077 169.395 750.72 169.395C717.363 169.395 701.754 186.046 696.766 213.278L681.767 297.213C677.288 324.614 686.755 341.266 720.146 341.266V341.299Z",
    fill: "#D4FB41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.92 80.1191L1145.23 172.492H1119.66C1074.08 172.492 1057.43 185.29 1049.63 229.796L1015.18 427.883H907.912L941.248 235.364C962.409 116.274 1006.83 80.1191 1145.81 80.1191H1161.92Z",
    fill: "#D4FB41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdrChartreuseLogo);
export default __webpack_public_path__ + "static/media/ordr-chartreuse-logo.d839cd643eda31c93a49a7af55271263.svg";
export { ForwardRef as ReactComponent };